import Adobe from '../../Images/Partner/Adobe.png';
import Autodesk from '../../Images/Partner/Autodesk.png';
 import Hp from '../../Images/Partner/Hp.png';
import Microsoft from '../../Images/Partner/Microsoft.png';
import ibm from '../../Images/Partner/ibm.png';
import Hewlett from '../../Images/Partner/Hewlett.png';
import dell from '../../Images/Partner/dell.png';
import yellow from '../../Images/Partner/yellow.png';
import g_cloud from '../../Images/Partner/g_cloud.png';
import aws from '../../Images/Partner/aws.png';



const Content =[
    {
        id:1,
        image: Adobe,
        alt:"Adobe",
    },
    {
        id:2,
        image: ibm,
        alt:"ibm",
    },
    {
        id:5,
        image: Microsoft,
        alt:"Adobe",
    },
    {
        id:3,
        image: Hewlett,
        alt:"hewlett",
    },
    {
        id:4,
        image: dell,
        alt:"dell",
    },
    {
        id:4,
        image: Hp,
        alt:"Adobe",
    },
 {
        id:6,
        image: yellow,
        alt:"yellow",
    },
    {
        id:7,
        image: aws,
        alt:"aws",
    },
    {
        id:7,
        image: g_cloud,
        alt:"g_cloud",
    },
     
  




  
];
export default Content;